<script>
    export let username;
    export let roles;
    import { links } from "svelte-navigator";

    let collapseIn = false;
    const url = location.pathname;
    const menus = [
        { title: "Home", url: "/" },
        { title: "ส่งคำร้อง", url: "/user_page" },
        { title: "Draft Request", url: "/admin/draftrequest/", role: "admin" },
        {
            title: "Approved Request",
            url: "/admin/approvedrequest/",
            role: "admin",
        },
        {
            title: "User",
            url: "/admin/user/",
            role: "admin",
        },
        {
            title: "Admin page",
            url: "/admin_page",
            role: "admin",
        },
    ];
</script>

<nav class="navbar navbar-default" role="navigation">
    <!-- Brand and toggle get grouped for better mobile display -->
    <div class="navbar-header">
        <button
            type="button"
            class="navbar-toggle"
            on:click={() => (collapseIn = !collapseIn)}
        >
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar" />
            <span class="icon-bar" />
            <span class="icon-bar" />
        </button>

        <a class="navbar-brand">tagging</a>
    </div>
    <!-- navbar content -->
    <div class="collapse navbar-collapse" use:links class:in={collapseIn}>
        <ul class="nav navbar-nav">
            {#each menus as menu}
                {#if !menu.role || roles.indexOf(menu.role) > -1}
                    <li class:active={url === menu.url}>
                        <a href={menu.url} noroute>{menu.title}</a>
                    </li>
                {/if}
            {/each}
        </ul>
        <ul class="nav navbar-nav navbar-right">
            {#if username}
                <li>
                    <a href="/user/edit_user_profile" noroute>{username}</a>
                </li>
                <li>
                    <a href="/user/sign-out" noroute>Sign out</a>
                </li>
            {:else}
                <li>
                    <a href="/user/sign-in" noroute>Sign in</a>
                </li>
            {/if}
        </ul>
    </div>
</nav>
